module.exports = __webpack_public_path__ + "img/battery_25.9ed58169.svg";